export default function MemberTradeRulesCtrl($scope, $sce, $wamp) {
  $wamp.call('org.eggs.traderules_list')
      .then(function (traderules) {
        $scope.traderules = traderules;
      });
}
